import $ from 'jquery'

const STORAGE_SHOWN = 'reka_modal_newsletter_shown'

if (!localStorage.getItem(STORAGE_SHOWN)) {
    $('#modal-newsletter').modal().on('hidden.bs.modal', () => localStorage.setItem(STORAGE_SHOWN, 1))
}